import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import { withStyles } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Proposal } from "../models";

import TextField from "../../common/TextField";
import CheckboxGroup from "../../common/CheckboxGroup";
import HelpLabel from "../../common/HelpLabel";
import Select from "../../common/Select";
import states from "../../common/states.json";
import { MAKE_OPTIONS } from "../../../api/constants";
import { getValue } from "../../../api/utils";

const styles = theme => ({
    rightAlign: {
        textAlign: "right"
    },
    button: {
        marginRight: theme.spacing(2)
    },
    gutterTop: {
        textAlign: "center",
        marginTop: ".6em"
    }
});

class GeneralTab extends Component {
    componentDidMount() {
        const { handleUnsavedFields } = this.props;
        document.title = "Proposal: General - Lessard Sams Outdoor Heritage Council";
        this.props.onRef(this);
        const _this = this;
        // FIXME: react-forms calls formDidUpdate when (if) validation is ran right away
        // making it appear there is a edited field even if there isn't
        // Reset fields to false to not require validation when mounted
        setTimeout(function() {
            handleUnsavedFields(false);
            _this.props.appContainer.current.scrollTop();
        }, 1);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    errorValidator = values => {
        const isRequired = val => {
            return !val ? "Required" : null;
        };
        var valObj = {
            name: isRequired(values.name),
            ml_year: isRequired(values.ml_year)
        };

        return valObj;
    };

    updateProposal(values, fromStepper) {
        const { id } = this.props.proposal;
        const { ormProposalUpdate, history, handleUnsavedFields, handleNext, proposal } = this.props;

        if (Number.isInteger(fromStepper)) {
            values.activeStep = fromStepper;
        }

        values.federal_funds_confirmation_document = proposal.federal_funds_confirmation_document;
        values.modify_date_label = proposal.modify_date_label;
        values.signup_criteria = proposal.signup_criteria;
        values.illustration = proposal.illustration;
        values.financial_audit = proposal.financial_audit;
        values.board_members = proposal.board_members;

        // Clear out fields that may no longer be shown
        if (values.activity_types.indexOf("Other") === -1) {
            values.activity_types_other = null; //all
            values.activity_other_desc = null; //p/ap
        }
        if (values.activity_types.indexOf("Protect in Fee") === -1) {
            values.fee_governement_approval = null; //p/ap
            values.fee_governement_approval_desc = null; //p/ap
            values.fee_free_of_protection = null; //p/ap
            values.fee_free_of_protection_desc = null; //p/ap
            values.fee_hunting_fishing = null; //p/ap
            values.fee_hunting_fishing_desc = null; //p/ap
            values.fee_hunting_fishing_after = null; //p/ap
            values.fee_hunting_fishing_after_desc = null; //p/ap
            values.output_acres_resourcetype_feepilt_wetland = 0;
            values.output_acres_resourcetype_feepilt_prairie = 0;
            values.output_acres_resourcetype_feepilt_forest = 0;
            values.output_acres_resourcetype_feepilt_habitat = 0;
            values.output_acres_resourcetype_feepilt_nativeprairie = 0;
            values.output_dollars_resourcetype_feepilt_wetland = 0;
            values.output_dollars_resourcetype_feepilt_prairie = 0;
            values.output_dollars_resourcetype_feepilt_forest = 0;
            values.output_dollars_resourcetype_feepilt_habitat = 0;
            values.output_dollars_resourcetype_feepilt_total = 0;
            values.output_acres_ecologicalsection_feepilt_metrourban = 0;
            values.output_acres_ecologicalsection_feepilt_forestprairie = 0;
            values.output_acres_ecologicalsection_feepilt_seforest = 0;
            values.output_acres_ecologicalsection_feepilt_prairie = 0;
            values.output_acres_ecologicalsection_feepilt_northernforest = 0;
            values.output_dollars_ecologicalsection_feepilt_metrourban = 0;
            values.output_dollars_ecologicalsection_feepilt_forestprairie = 0;
            values.output_dollars_ecologicalsection_feepilt_seforest = 0;
            values.output_dollars_ecologicalsection_feepilt_prairie = 0;
            values.output_dollars_ecologicalsection_feepilt_northernforest = 0;
            values.output_acres_resourcetype_feepilt_total = 0;
            values.output_dollars_resourcetype_feepilt_total = 0;
            values.output_acres_ecologicalsection_feepilt_total = 0;
            values.output_dollars_ecologicalsection_feepilt_total = 0;
            
            values.output_acres_resourcetype_feewopilt_wetland = 0;
            values.output_acres_resourcetype_feewopilt_prairie = 0;
            values.output_acres_resourcetype_feewopilt_forest = 0;
            values.output_acres_resourcetype_feewopilt_habitat = 0;
            values.output_acres_resourcetype_feewopilt_nativeprairie = 0;
            values.output_dollars_resourcetype_feewopilt_wetland = 0;
            values.output_dollars_resourcetype_feewopilt_prairie = 0;
            values.output_dollars_resourcetype_feewopilt_forest = 0;
            values.output_dollars_resourcetype_feewopilt_habitat = 0;
            values.output_dollars_resourcetype_feewopilt_total = 0;
            values.output_acres_ecologicalsection_feewopilt_metrourban = 0;
            values.output_acres_ecologicalsection_feewopilt_forestprairie = 0;
            values.output_acres_ecologicalsection_feewopilt_seforest = 0;
            values.output_acres_ecologicalsection_feewopilt_prairie = 0;
            values.output_acres_ecologicalsection_feewopilt_northernforest = 0;
            values.output_dollars_ecologicalsection_feewopilt_metrourban = 0;
            values.output_dollars_ecologicalsection_feewopilt_forestprairie = 0;
            values.output_dollars_ecologicalsection_feewopilt_seforest = 0;
            values.output_dollars_ecologicalsection_feewopilt_prairie = 0;
            values.output_dollars_ecologicalsection_feewopilt_northernforest = 0;
            values.output_acres_resourcetype_feewopilt_total = 0;
            values.output_dollars_resourcetype_feewopilt_total = 0;
            values.output_acres_ecologicalsection_feewopilt_total = 0;
            values.output_dollars_ecologicalsection_feewopilt_total = 0;
            values.output_acres_resourcetype_total_wetland = 
                values.output_acres_resourcetype_restore_wetland +
                values.output_acres_resourcetype_feepilt_wetland +
                values.output_acres_resourcetype_feewopilt_wetland +
                values.output_acres_resourcetype_easement_wetland +
                values.output_acres_resourcetype_enhance_wetland;
            values.output_acres_resourcetype_total_prairie = 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_enhance_prairie;
            values.output_acres_resourcetype_total_forest = 
                values.output_acres_resourcetype_restore_forest +
                values.output_acres_resourcetype_feepilt_forest +
                values.output_acres_resourcetype_feewopilt_forest +
                values.output_acres_resourcetype_easement_forest +
                values.output_acres_resourcetype_enhance_forest;
            values.output_acres_resourcetype_total_habitat = 
                values.output_acres_resourcetype_restore_habitat +
                values.output_acres_resourcetype_feepilt_habitat +
                values.output_acres_resourcetype_feewopilt_habitat +
                values.output_acres_resourcetype_easement_habitat +
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie +
                values.output_acres_resourcetype_total_forest +
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_total_wetland = 
                values.output_dollars_resourcetype_restore_wetland +
                values.output_dollars_resourcetype_feepilt_wetland +
                values.output_dollars_resourcetype_feewopilt_wetland +
                values.output_dollars_resourcetype_easement_wetland +
                values.output_dollars_resourcetype_enhance_wetland;
            values.output_dollars_resourcetype_total_prairie = 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_enhance_prairie;
            values.output_dollars_resourcetype_total_forest = 
                values.output_dollars_resourcetype_restore_forest +
                values.output_dollars_resourcetype_feepilt_forest +
                values.output_dollars_resourcetype_feewopilt_forest +
                values.output_dollars_resourcetype_easement_forest +
                values.output_dollars_resourcetype_enhance_forest;
            values.output_dollars_resourcetype_total_habitat = 
                values.output_dollars_resourcetype_restore_habitat +
                values.output_dollars_resourcetype_feepilt_habitat +
                values.output_dollars_resourcetype_feewopilt_habitat +
                values.output_dollars_resourcetype_easement_habitat +
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie +
                values.output_dollars_resourcetype_total_forest +
                values.output_dollars_resourcetype_total_habitat;
            values.output_acres_ecologicalsection_total_metrourban = 
                values.output_acres_ecologicalsection_restore_metrourban +
                values.output_acres_ecologicalsection_feepilt_metrourban +
                values.output_acres_ecologicalsection_feewopilt_metrourban +
                values.output_acres_ecologicalsection_easement_metrourban +
                values.output_acres_ecologicalsection_enhance_metrourban;
            values.output_acres_ecologicalsection_total_forestprairie = 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_enhance_forestprairie;
            values.output_acres_ecologicalsection_total_seforest = 
                values.output_acres_ecologicalsection_restore_seforest +
                values.output_acres_ecologicalsection_feepilt_seforest +
                values.output_acres_ecologicalsection_feewopilt_seforest +
                values.output_acres_ecologicalsection_easement_seforest +
                values.output_acres_ecologicalsection_enhance_seforest;
            values.output_acres_ecologicalsection_total_prairie = 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_enhance_prairie;
            values.output_acres_ecologicalsection_total_northernforest = 
                values.output_acres_ecologicalsection_restore_northernforest +
                values.output_acres_ecologicalsection_feepilt_northernforest +
                values.output_acres_ecologicalsection_feewopilt_northernforest +
                values.output_acres_ecologicalsection_easement_northernforest +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_total_metrourban +
                values.output_acres_ecologicalsection_total_forestprairie +
                values.output_acres_ecologicalsection_total_seforest +
                values.output_acres_ecologicalsection_total_prairie +
                values.output_acres_ecologicalsection_total_northernforest;
            values.output_dollars_ecologicalsection_total_metrourban = 
                values.output_dollars_ecologicalsection_restore_metrourban +
                values.output_dollars_ecologicalsection_feepilt_metrourban +
                values.output_dollars_ecologicalsection_feewopilt_metrourban +
                values.output_dollars_ecologicalsection_easement_metrourban +
                values.output_dollars_ecologicalsection_enhance_metrourban;
            values.output_dollars_ecologicalsection_total_forestprairie = 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_enhance_forestprairie;
            values.output_dollars_ecologicalsection_total_seforest = 
                values.output_dollars_ecologicalsection_restore_seforest +
                values.output_dollars_ecologicalsection_feepilt_seforest +
                values.output_dollars_ecologicalsection_feewopilt_seforest +
                values.output_dollars_ecologicalsection_easement_seforest +
                values.output_dollars_ecologicalsection_enhance_seforest;
            values.output_dollars_ecologicalsection_total_prairie = 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_enhance_prairie;
            values.output_dollars_ecologicalsection_total_northernforest = 
                values.output_dollars_ecologicalsection_restore_northernforest +
                values.output_dollars_ecologicalsection_feepilt_northernforest +
                values.output_dollars_ecologicalsection_feewopilt_northernforest +
                values.output_dollars_ecologicalsection_easement_northernforest +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_total_metrourban +
                values.output_dollars_ecologicalsection_total_forestprairie +
                values.output_dollars_ecologicalsection_total_seforest +
                values.output_dollars_ecologicalsection_total_prairie +
                values.output_dollars_ecologicalsection_total_northernforest;
        }
        if (values.activity_types.indexOf("Protect in Easement") === -1) {
            values.easement_free_of_protection = null; //p/ap
            values.easement_free_of_protection_desc = null; //p/ap
            values.easement_public_use = null; //p/ap
            values.easement_public_use_desc = null; //p/ap
            values.output_acres_resourcetype_easement_wetland = 0;
            values.output_acres_resourcetype_easement_prairie = 0;
            values.output_acres_resourcetype_easement_forest = 0;
            values.output_acres_resourcetype_easement_habitat = 0;
            values.output_acres_resourcetype_easement_nativeprairie = 0;
            values.output_dollars_resourcetype_easement_wetland = 0;
            values.output_dollars_resourcetype_easement_prairie = 0;
            values.output_dollars_resourcetype_easement_forest = 0;
            values.output_dollars_resourcetype_easement_habitat = 0;
            values.output_dollars_resourcetype_easement_total = 0;
            values.output_acres_ecologicalsection_easement_metrourban = 0;
            values.output_acres_ecologicalsection_easement_forestprairie = 0;
            values.output_acres_ecologicalsection_easement_seforest = 0;
            values.output_acres_ecologicalsection_easement_prairie = 0;
            values.output_acres_ecologicalsection_easement_northernforest = 0;
            values.output_dollars_ecologicalsection_easement_metrourban = 0;
            values.output_dollars_ecologicalsection_easement_forestprairie = 0;
            values.output_dollars_ecologicalsection_easement_seforest = 0;
            values.output_dollars_ecologicalsection_easement_prairie = 0;
            values.output_dollars_ecologicalsection_easement_northernforest = 0;
            values.output_acres_resourcetype_easement_total = 0;
            values.output_dollars_resourcetype_easement_total = 0;
            values.output_acres_ecologicalsection_easement_total = 0;
            values.output_dollars_ecologicalsection_easement_total = 0;
            values.output_acres_resourcetype_total_wetland = 
                values.output_acres_resourcetype_restore_wetland +
                values.output_acres_resourcetype_feepilt_wetland +
                values.output_acres_resourcetype_feewopilt_wetland +
                values.output_acres_resourcetype_easement_wetland +
                values.output_acres_resourcetype_enhance_wetland;
            values.output_acres_resourcetype_total_prairie = 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_enhance_prairie;
            values.output_acres_resourcetype_total_forest = 
                values.output_acres_resourcetype_restore_forest +
                values.output_acres_resourcetype_feepilt_forest +
                values.output_acres_resourcetype_feewopilt_forest +
                values.output_acres_resourcetype_easement_forest +
                values.output_acres_resourcetype_enhance_forest;
            values.output_acres_resourcetype_total_habitat = 
                values.output_acres_resourcetype_restore_habitat +
                values.output_acres_resourcetype_feepilt_habitat +
                values.output_acres_resourcetype_feewopilt_habitat +
                values.output_acres_resourcetype_easement_habitat +
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie +
                values.output_acres_resourcetype_total_forest +
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_total_wetland = 
                values.output_dollars_resourcetype_restore_wetland +
                values.output_dollars_resourcetype_feepilt_wetland +
                values.output_dollars_resourcetype_feewopilt_wetland +
                values.output_dollars_resourcetype_easement_wetland +
                values.output_dollars_resourcetype_enhance_wetland;
            values.output_dollars_resourcetype_total_prairie = 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_enhance_prairie;
            values.output_dollars_resourcetype_total_forest = 
                values.output_dollars_resourcetype_restore_forest +
                values.output_dollars_resourcetype_feepilt_forest +
                values.output_dollars_resourcetype_feewopilt_forest +
                values.output_dollars_resourcetype_easement_forest +
                values.output_dollars_resourcetype_enhance_forest;
            values.output_dollars_resourcetype_total_habitat = 
                values.output_dollars_resourcetype_restore_habitat +
                values.output_dollars_resourcetype_feepilt_habitat +
                values.output_dollars_resourcetype_feewopilt_habitat +
                values.output_dollars_resourcetype_easement_habitat +
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie +
                values.output_dollars_resourcetype_total_forest +
                values.output_dollars_resourcetype_total_habitat;
            values.output_acres_ecologicalsection_total_metrourban = 
                values.output_acres_ecologicalsection_restore_metrourban +
                values.output_acres_ecologicalsection_feepilt_metrourban +
                values.output_acres_ecologicalsection_feewopilt_metrourban +
                values.output_acres_ecologicalsection_easement_metrourban +
                values.output_acres_ecologicalsection_enhance_metrourban;
            values.output_acres_ecologicalsection_total_forestprairie = 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_enhance_forestprairie;
            values.output_acres_ecologicalsection_total_seforest = 
                values.output_acres_ecologicalsection_restore_seforest +
                values.output_acres_ecologicalsection_feepilt_seforest +
                values.output_acres_ecologicalsection_feewopilt_seforest +
                values.output_acres_ecologicalsection_easement_seforest +
                values.output_acres_ecologicalsection_enhance_seforest;
            values.output_acres_ecologicalsection_total_prairie = 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_enhance_prairie;
            values.output_acres_ecologicalsection_total_northernforest = 
                values.output_acres_ecologicalsection_restore_northernforest +
                values.output_acres_ecologicalsection_feepilt_northernforest +
                values.output_acres_ecologicalsection_feewopilt_northernforest +
                values.output_acres_ecologicalsection_easement_northernforest +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_total_metrourban +
                values.output_acres_ecologicalsection_total_forestprairie +
                values.output_acres_ecologicalsection_total_seforest +
                values.output_acres_ecologicalsection_total_prairie +
                values.output_acres_ecologicalsection_total_northernforest;
            values.output_dollars_ecologicalsection_total_metrourban = 
                values.output_dollars_ecologicalsection_restore_metrourban +
                values.output_dollars_ecologicalsection_feepilt_metrourban +
                values.output_dollars_ecologicalsection_feewopilt_metrourban +
                values.output_dollars_ecologicalsection_easement_metrourban +
                values.output_dollars_ecologicalsection_enhance_metrourban;
            values.output_dollars_ecologicalsection_total_forestprairie = 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_enhance_forestprairie;
            values.output_dollars_ecologicalsection_total_seforest = 
                values.output_dollars_ecologicalsection_restore_seforest +
                values.output_dollars_ecologicalsection_feepilt_seforest +
                values.output_dollars_ecologicalsection_feewopilt_seforest +
                values.output_dollars_ecologicalsection_easement_seforest +
                values.output_dollars_ecologicalsection_enhance_seforest;
            values.output_dollars_ecologicalsection_total_prairie = 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_enhance_prairie;
            values.output_dollars_ecologicalsection_total_northernforest = 
                values.output_dollars_ecologicalsection_restore_northernforest +
                values.output_dollars_ecologicalsection_feepilt_northernforest +
                values.output_dollars_ecologicalsection_feewopilt_northernforest +
                values.output_dollars_ecologicalsection_easement_northernforest +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_total_metrourban +
                values.output_dollars_ecologicalsection_total_forestprairie +
                values.output_dollars_ecologicalsection_total_seforest +
                values.output_dollars_ecologicalsection_total_prairie +
                values.output_dollars_ecologicalsection_total_northernforest;
        }
        if (values.activity_types.indexOf("Protect in Easement") === -1 && values.activity_types.indexOf("Protect in Fee") === -1) {
            values.feeeasement_trailroads = null; //p/ap
            values.trail_types = null; //p/ap
            values.trails_continued_use = null; //p/ap
            values.trails_continued_use_desc = null; //p/ap
            values.feeeasement_trailroads_new = null; //p/ap
            values.trail_types_new = null; //p/ap
            values.trail_types_new_maintenance = null; //p/ap
            values.land_restored = null; //p/ap
            values.land_restored_how = null; //p/ap
        }
        if (values.activity_types.indexOf("Restore") === -1 && values.activity_types.indexOf("Enhance") === -1) {
            values.restoration_follow_bmp = null;//p/ap
            values.restoration_follow_bmp_desc = null;//p/ap
            values.restoration_on_protected_land = null;//p/ap
            values.rep_protected_desc = null;//p/ap
            values.restoration_on_protected_land_yes = [];//p/ap
            values.restoration_on_protected_land_yes_other = null;//p/ap
        }
        if (values.activity_types.indexOf("Restore") === -1) {
            values.output_acres_resourcetype_restore_wetland = 0;
            values.output_acres_resourcetype_restore_prairie = 0;
            values.output_acres_resourcetype_restore_forest = 0;
            values.output_acres_resourcetype_restore_habitat = 0;
            values.output_acres_resourcetype_restore_nativeprairie = 0;
            values.output_dollars_resourcetype_restore_wetland = 0;
            values.output_dollars_resourcetype_restore_prairie = 0;
            values.output_dollars_resourcetype_restore_forest = 0;
            values.output_dollars_resourcetype_restore_habitat = 0;
            values.output_dollars_resourcetype_restore_total = 0;
            values.output_acres_ecologicalsection_restore_metrourban = 0;
            values.output_acres_ecologicalsection_restore_forestprairie = 0;
            values.output_acres_ecologicalsection_restore_seforest = 0;
            values.output_acres_ecologicalsection_restore_prairie = 0;
            values.output_acres_ecologicalsection_restore_northernforest = 0;
            values.output_dollars_ecologicalsection_restore_metrourban = 0;
            values.output_dollars_ecologicalsection_restore_forestprairie = 0;
            values.output_dollars_ecologicalsection_restore_seforest = 0;
            values.output_dollars_ecologicalsection_restore_prairie = 0;
            values.output_dollars_ecologicalsection_restore_northernforest = 0;
            values.output_acres_resourcetype_restore_total = 0;
            values.output_dollars_resourcetype_restore_total = 0;
            values.output_acres_ecologicalsection_restore_total = 0;
            values.output_dollars_ecologicalsection_restore_total = 0;
            values.output_acres_resourcetype_total_wetland = 
                values.output_acres_resourcetype_restore_wetland +
                values.output_acres_resourcetype_feepilt_wetland +
                values.output_acres_resourcetype_feewopilt_wetland +
                values.output_acres_resourcetype_easement_wetland +
                values.output_acres_resourcetype_enhance_wetland;
            values.output_acres_resourcetype_total_prairie = 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_enhance_prairie;
            values.output_acres_resourcetype_total_forest = 
                values.output_acres_resourcetype_restore_forest +
                values.output_acres_resourcetype_feepilt_forest +
                values.output_acres_resourcetype_feewopilt_forest +
                values.output_acres_resourcetype_easement_forest +
                values.output_acres_resourcetype_enhance_forest;
            values.output_acres_resourcetype_total_habitat = 
                values.output_acres_resourcetype_restore_habitat +
                values.output_acres_resourcetype_feepilt_habitat +
                values.output_acres_resourcetype_feewopilt_habitat +
                values.output_acres_resourcetype_easement_habitat +
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie +
                values.output_acres_resourcetype_total_forest +
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_total_wetland = 
                values.output_dollars_resourcetype_restore_wetland +
                values.output_dollars_resourcetype_feepilt_wetland +
                values.output_dollars_resourcetype_feewopilt_wetland +
                values.output_dollars_resourcetype_easement_wetland +
                values.output_dollars_resourcetype_enhance_wetland;
            values.output_dollars_resourcetype_total_prairie = 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_enhance_prairie;
            values.output_dollars_resourcetype_total_forest = 
                values.output_dollars_resourcetype_restore_forest +
                values.output_dollars_resourcetype_feepilt_forest +
                values.output_dollars_resourcetype_feewopilt_forest +
                values.output_dollars_resourcetype_easement_forest +
                values.output_dollars_resourcetype_enhance_forest;
            values.output_dollars_resourcetype_total_habitat = 
                values.output_dollars_resourcetype_restore_habitat +
                values.output_dollars_resourcetype_feepilt_habitat +
                values.output_dollars_resourcetype_feewopilt_habitat +
                values.output_dollars_resourcetype_easement_habitat +
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie +
                values.output_dollars_resourcetype_total_forest +
                values.output_dollars_resourcetype_total_habitat;
            values.output_acres_ecologicalsection_total_metrourban = 
                values.output_acres_ecologicalsection_restore_metrourban +
                values.output_acres_ecologicalsection_feepilt_metrourban +
                values.output_acres_ecologicalsection_feewopilt_metrourban +
                values.output_acres_ecologicalsection_easement_metrourban +
                values.output_acres_ecologicalsection_enhance_metrourban;
            values.output_acres_ecologicalsection_total_forestprairie = 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_enhance_forestprairie;
            values.output_acres_ecologicalsection_total_seforest = 
                values.output_acres_ecologicalsection_restore_seforest +
                values.output_acres_ecologicalsection_feepilt_seforest +
                values.output_acres_ecologicalsection_feewopilt_seforest +
                values.output_acres_ecologicalsection_easement_seforest +
                values.output_acres_ecologicalsection_enhance_seforest;
            values.output_acres_ecologicalsection_total_prairie = 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_enhance_prairie;
            values.output_acres_ecologicalsection_total_northernforest = 
                values.output_acres_ecologicalsection_restore_northernforest +
                values.output_acres_ecologicalsection_feepilt_northernforest +
                values.output_acres_ecologicalsection_feewopilt_northernforest +
                values.output_acres_ecologicalsection_easement_northernforest +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_total_metrourban +
                values.output_acres_ecologicalsection_total_forestprairie +
                values.output_acres_ecologicalsection_total_seforest +
                values.output_acres_ecologicalsection_total_prairie +
                values.output_acres_ecologicalsection_total_northernforest;
            values.output_dollars_ecologicalsection_total_metrourban = 
                values.output_dollars_ecologicalsection_restore_metrourban +
                values.output_dollars_ecologicalsection_feepilt_metrourban +
                values.output_dollars_ecologicalsection_feewopilt_metrourban +
                values.output_dollars_ecologicalsection_easement_metrourban +
                values.output_dollars_ecologicalsection_enhance_metrourban;
            values.output_dollars_ecologicalsection_total_forestprairie = 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_enhance_forestprairie;
            values.output_dollars_ecologicalsection_total_seforest = 
                values.output_dollars_ecologicalsection_restore_seforest +
                values.output_dollars_ecologicalsection_feepilt_seforest +
                values.output_dollars_ecologicalsection_feewopilt_seforest +
                values.output_dollars_ecologicalsection_easement_seforest +
                values.output_dollars_ecologicalsection_enhance_seforest;
            values.output_dollars_ecologicalsection_total_prairie = 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_enhance_prairie;
            values.output_dollars_ecologicalsection_total_northernforest = 
                values.output_dollars_ecologicalsection_restore_northernforest +
                values.output_dollars_ecologicalsection_feepilt_northernforest +
                values.output_dollars_ecologicalsection_feewopilt_northernforest +
                values.output_dollars_ecologicalsection_easement_northernforest +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_total_metrourban +
                values.output_dollars_ecologicalsection_total_forestprairie +
                values.output_dollars_ecologicalsection_total_seforest +
                values.output_dollars_ecologicalsection_total_prairie +
                values.output_dollars_ecologicalsection_total_northernforest;
        }
        if (values.activity_types.indexOf("Enhance") === -1) {
            values.output_acres_resourcetype_enhance_wetland = 0;
            values.output_acres_resourcetype_enhance_prairie = 0;
            values.output_acres_resourcetype_enhance_forest = 0;
            values.output_acres_resourcetype_enhance_habitat = 0;
            values.output_acres_resourcetype_enhance_nativeprairie = 0;
            values.output_dollars_resourcetype_enhance_wetland = 0;
            values.output_dollars_resourcetype_enhance_prairie = 0;
            values.output_dollars_resourcetype_enhance_forest = 0;
            values.output_dollars_resourcetype_enhance_habitat = 0;
            values.output_acres_ecologicalsection_enhance_metrourban = 0;
            values.output_acres_ecologicalsection_enhance_forestprairie = 0;
            values.output_acres_ecologicalsection_enhance_seforest = 0;
            values.output_acres_ecologicalsection_enhance_prairie = 0;
            values.output_acres_ecologicalsection_enhance_northernforest = 0;
            values.output_dollars_ecologicalsection_enhance_metrourban = 0;
            values.output_dollars_ecologicalsection_enhance_forestprairie = 0;
            values.output_dollars_ecologicalsection_enhance_seforest = 0;
            values.output_dollars_ecologicalsection_enhance_prairie = 0;
            values.output_dollars_ecologicalsection_enhance_northernforest = 0;
            values.output_acres_resourcetype_enhance_total = 0;
            values.output_dollars_resourcetype_enhance_total = 0;
            values.output_acres_ecologicalsection_enhance_total = 0;
            values.output_dollars_ecologicalsection_enhance_total = 0;
            values.output_acres_resourcetype_total_wetland = 
                values.output_acres_resourcetype_restore_wetland +
                values.output_acres_resourcetype_feepilt_wetland +
                values.output_acres_resourcetype_feewopilt_wetland +
                values.output_acres_resourcetype_easement_wetland +
                values.output_acres_resourcetype_enhance_wetland;
            values.output_acres_resourcetype_total_prairie = 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_enhance_prairie;
            values.output_acres_resourcetype_total_forest = 
                values.output_acres_resourcetype_restore_forest +
                values.output_acres_resourcetype_feepilt_forest +
                values.output_acres_resourcetype_feewopilt_forest +
                values.output_acres_resourcetype_easement_forest +
                values.output_acres_resourcetype_enhance_forest;
            values.output_acres_resourcetype_total_habitat = 
                values.output_acres_resourcetype_restore_habitat +
                values.output_acres_resourcetype_feepilt_habitat +
                values.output_acres_resourcetype_feewopilt_habitat +
                values.output_acres_resourcetype_easement_habitat +
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie +
                values.output_acres_resourcetype_total_forest +
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_total_wetland = 
                values.output_dollars_resourcetype_restore_wetland +
                values.output_dollars_resourcetype_feepilt_wetland +
                values.output_dollars_resourcetype_feewopilt_wetland +
                values.output_dollars_resourcetype_easement_wetland +
                values.output_dollars_resourcetype_enhance_wetland;
            values.output_dollars_resourcetype_total_prairie = 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_enhance_prairie;
            values.output_dollars_resourcetype_total_forest = 
                values.output_dollars_resourcetype_restore_forest +
                values.output_dollars_resourcetype_feepilt_forest +
                values.output_dollars_resourcetype_feewopilt_forest +
                values.output_dollars_resourcetype_easement_forest +
                values.output_dollars_resourcetype_enhance_forest;
            values.output_dollars_resourcetype_total_habitat = 
                values.output_dollars_resourcetype_restore_habitat +
                values.output_dollars_resourcetype_feepilt_habitat +
                values.output_dollars_resourcetype_feewopilt_habitat +
                values.output_dollars_resourcetype_easement_habitat +
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie +
                values.output_dollars_resourcetype_total_forest +
                values.output_dollars_resourcetype_total_habitat;
            values.output_acres_ecologicalsection_total_metrourban = 
                values.output_acres_ecologicalsection_restore_metrourban +
                values.output_acres_ecologicalsection_feepilt_metrourban +
                values.output_acres_ecologicalsection_feewopilt_metrourban +
                values.output_acres_ecologicalsection_easement_metrourban +
                values.output_acres_ecologicalsection_enhance_metrourban;
            values.output_acres_ecologicalsection_total_forestprairie = 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_enhance_forestprairie;
            values.output_acres_ecologicalsection_total_seforest = 
                values.output_acres_ecologicalsection_restore_seforest +
                values.output_acres_ecologicalsection_feepilt_seforest +
                values.output_acres_ecologicalsection_feewopilt_seforest +
                values.output_acres_ecologicalsection_easement_seforest +
                values.output_acres_ecologicalsection_enhance_seforest;
            values.output_acres_ecologicalsection_total_prairie = 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_enhance_prairie;
            values.output_acres_ecologicalsection_total_northernforest = 
                values.output_acres_ecologicalsection_restore_northernforest +
                values.output_acres_ecologicalsection_feepilt_northernforest +
                values.output_acres_ecologicalsection_feewopilt_northernforest +
                values.output_acres_ecologicalsection_easement_northernforest +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_total_metrourban +
                values.output_acres_ecologicalsection_total_forestprairie +
                values.output_acres_ecologicalsection_total_seforest +
                values.output_acres_ecologicalsection_total_prairie +
                values.output_acres_ecologicalsection_total_northernforest;
            values.output_dollars_ecologicalsection_total_metrourban = 
                values.output_dollars_ecologicalsection_restore_metrourban +
                values.output_dollars_ecologicalsection_feepilt_metrourban +
                values.output_dollars_ecologicalsection_feewopilt_metrourban +
                values.output_dollars_ecologicalsection_easement_metrourban +
                values.output_dollars_ecologicalsection_enhance_metrourban;
            values.output_dollars_ecologicalsection_total_forestprairie = 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_enhance_forestprairie;
            values.output_dollars_ecologicalsection_total_seforest = 
                values.output_dollars_ecologicalsection_restore_seforest +
                values.output_dollars_ecologicalsection_feepilt_seforest +
                values.output_dollars_ecologicalsection_feewopilt_seforest +
                values.output_dollars_ecologicalsection_easement_seforest +
                values.output_dollars_ecologicalsection_enhance_seforest;
            values.output_dollars_ecologicalsection_total_prairie = 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_enhance_prairie;
            values.output_dollars_ecologicalsection_total_northernforest = 
                values.output_dollars_ecologicalsection_restore_northernforest +
                values.output_dollars_ecologicalsection_feepilt_northernforest +
                values.output_dollars_ecologicalsection_feewopilt_northernforest +
                values.output_dollars_ecologicalsection_easement_northernforest +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_total_metrourban +
                values.output_dollars_ecologicalsection_total_forestprairie +
                values.output_dollars_ecologicalsection_total_seforest +
                values.output_dollars_ecologicalsection_total_prairie +
                values.output_dollars_ecologicalsection_total_northernforest;
        }
        if (values.eco_regions.indexOf("Forest / Prairie Transition") === -1) {
            values.lsohc_section_priorities = values.lsohc_section_priorities.filter(
                item => (
                    item !== "Forest / Prairie Transition - Protect, enhance, and restore migratory habitat for waterfowl and related species, so as to increase migratory and breeding success" &&
                    item !== "Forest / Prairie Transition - Protect, enhance, and restore rare native remnant prairie" &&
                    item !== "Forest / Prairie Transition - Protect, enhance, and restore wild rice wetlands, shallow lakes, wetland/grassland complexes, aspen parklands, and shoreland that provide critical habitat for game and nongame wildlife" &&
                    item !== "Forest / Prairie Transition - Protect from long-term or permanent endangerment from invasive species" &&
                    item !== "Forest / Prairie Transition - Protect, restore, and enhance habitat for waterfowl, upland birds, and species of greatest conservation need"
                )
            ) //p/ap
            values.outcomes_forest_prairie_transition = []; //all
            values.outcomes_forest_prairie_transition_explain = null;//all
            //t3 
            //0 all forestprairie table values
            values.output_acres_ecologicalsection_restore_forestprairie = 0;
            values.output_acres_ecologicalsection_feepilt_forestprairie = 0;
            values.output_acres_ecologicalsection_feewopilt_forestprairie = 0;
            values.output_acres_ecologicalsection_easement_forestprairie = 0;
            values.output_acres_ecologicalsection_enhance_forestprairie = 0;
            // 0 forest prairie total
            values.output_acres_ecologicalsection_total_forestprairie = 0;
            // recalculate all type totals
            values.output_acres_ecologicalsection_restore_total = 
                values.output_acres_ecologicalsection_restore_metrourban + 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_restore_seforest + 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_restore_northernforest;
            values.output_acres_ecologicalsection_feepilt_total = 
                values.output_acres_ecologicalsection_feepilt_metrourban + 
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feepilt_seforest + 
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feepilt_northernforest;
            values.output_acres_ecologicalsection_feewopilt_total = 
                values.output_acres_ecologicalsection_feewopilt_metrourban + 
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_seforest + 
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_northernforest;
            values.output_acres_ecologicalsection_easement_total = 
                values.output_acres_ecologicalsection_easement_metrourban + 
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_easement_seforest + 
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_easement_northernforest;
            values.output_acres_ecologicalsection_enhance_total = 
                values.output_acres_ecologicalsection_enhance_metrourban + 
                values.output_acres_ecologicalsection_enhance_forestprairie +
                values.output_acres_ecologicalsection_enhance_seforest + 
                values.output_acres_ecologicalsection_enhance_prairie +
                values.output_acres_ecologicalsection_enhance_northernforest;
            // grand total
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_restore_total +
                values.output_acres_ecologicalsection_feepilt_total + 
                values.output_acres_ecologicalsection_feewopilt_total + 
                values.output_acres_ecologicalsection_easement_total +
                values.output_acres_ecologicalsection_enhance_total;


            values.output_dollars_ecologicalsection_restore_forestprairie = 0;
            values.output_dollars_ecologicalsection_feepilt_forestprairie = 0;
            values.output_dollars_ecologicalsection_feewopilt_forestprairie = 0;
            values.output_dollars_ecologicalsection_easement_forestprairie = 0;
            values.output_dollars_ecologicalsection_enhance_forestprairie = 0;
            values.output_dollars_ecologicalsection_total_forestprairie = 0;
            values.output_dollars_ecologicalsection_restore_total = 
                values.output_dollars_ecologicalsection_restore_metrourban + 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_restore_seforest + 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_restore_northernforest;
            values.output_dollars_ecologicalsection_feepilt_total = 
                values.output_dollars_ecologicalsection_feepilt_metrourban + 
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_seforest + 
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feepilt_northernforest;
            values.output_dollars_ecologicalsection_feewopilt_total = 
                values.output_dollars_ecologicalsection_feewopilt_metrourban + 
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_seforest + 
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_northernforest;
            values.output_dollars_ecologicalsection_easement_total = 
                values.output_dollars_ecologicalsection_easement_metrourban + 
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_easement_seforest + 
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_easement_northernforest;
            values.output_dollars_ecologicalsection_enhance_total = 
                values.output_dollars_ecologicalsection_enhance_metrourban + 
                values.output_dollars_ecologicalsection_enhance_forestprairie +
                values.output_dollars_ecologicalsection_enhance_seforest + 
                values.output_dollars_ecologicalsection_enhance_prairie +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_restore_total +
                values.output_dollars_ecologicalsection_feepilt_total + 
                values.output_dollars_ecologicalsection_feewopilt_total + 
                values.output_dollars_ecologicalsection_easement_total +
                values.output_dollars_ecologicalsection_enhance_total;
        }
        if (values.eco_regions.indexOf("Metro / Urban") === -1) {
            values.lsohc_section_priorities = values.lsohc_section_priorities.filter(
                item => (
                    item !== "Metro / Urban - Enhance and restore coldwater fisheries systems" &&
                    item !== "Metro / Urban - Protect, enhance, and restore remnant native prairie, Big Woods forests, and oak savanna with an emphasis on areas with high biological diversity" &&
                    item !== "Metro / Urban - Protect, enhance, and restore riparian and littoral habitats on lakes to benefit game and nongame fish species" &&
                    item !== "Metro / Urban - Protect from long-term or permanent endangerment from invasive species" &&
                    item !== "Metro / Urban - Protect habitat corridors, with emphasis on the Minnesota, Mississippi, and St. Croix rivers (bluff to floodplain)"
                )
            )//p/ap
            values.outcomes_metro_urban = [];//all
            values.outcomes_metro_urban_explain = null;//all
            values.output_acres_ecologicalsection_restore_metrourban = 0;
            values.output_acres_ecologicalsection_feepilt_metrourban = 0;
            values.output_acres_ecologicalsection_feewopilt_metrourban = 0;
            values.output_acres_ecologicalsection_easement_metrourban = 0;
            values.output_acres_ecologicalsection_enhance_metrourban = 0;
            values.output_dollars_ecologicalsection_restore_metrourban = 0;
            values.output_dollars_ecologicalsection_feepilt_metrourban = 0;
            values.output_dollars_ecologicalsection_feewopilt_metrourban = 0;
            values.output_dollars_ecologicalsection_easement_metrourban = 0;
            values.output_dollars_ecologicalsection_enhance_metrourban = 0;
            values.output_acres_ecologicalsection_total_metrourban = 0;
            values.output_dollars_ecologicalsection_total_metrourban = 0;
            values.output_acres_ecologicalsection_restore_total = 
                values.output_acres_ecologicalsection_restore_metrourban + 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_restore_seforest + 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_restore_northernforest;
            values.output_acres_ecologicalsection_feepilt_total = 
                values.output_acres_ecologicalsection_feepilt_metrourban + 
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feepilt_seforest + 
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feepilt_northernforest;
            values.output_acres_ecologicalsection_feewopilt_total = 
                values.output_acres_ecologicalsection_feewopilt_metrourban + 
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_seforest + 
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_northernforest;
            values.output_acres_ecologicalsection_easement_total = 
                values.output_acres_ecologicalsection_easement_metrourban + 
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_easement_seforest + 
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_easement_northernforest;
            values.output_acres_ecologicalsection_enhance_total = 
                values.output_acres_ecologicalsection_enhance_metrourban + 
                values.output_acres_ecologicalsection_enhance_forestprairie +
                values.output_acres_ecologicalsection_enhance_seforest + 
                values.output_acres_ecologicalsection_enhance_prairie +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_restore_total +
                values.output_acres_ecologicalsection_feepilt_total + 
                values.output_acres_ecologicalsection_feewopilt_total + 
                values.output_acres_ecologicalsection_easement_total +
                values.output_acres_ecologicalsection_enhance_total;
            values.output_dollars_ecologicalsection_restore_total = 
                values.output_dollars_ecologicalsection_restore_metrourban + 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_restore_seforest + 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_restore_northernforest;
            values.output_dollars_ecologicalsection_feepilt_total = 
                values.output_dollars_ecologicalsection_feepilt_metrourban + 
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_seforest + 
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feepilt_northernforest;
            values.output_dollars_ecologicalsection_feewopilt_total = 
                values.output_dollars_ecologicalsection_feewopilt_metrourban + 
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_seforest + 
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_northernforest;
            values.output_dollars_ecologicalsection_easement_total = 
                values.output_dollars_ecologicalsection_easement_metrourban + 
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_easement_seforest + 
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_easement_northernforest;
            values.output_dollars_ecologicalsection_enhance_total = 
                values.output_dollars_ecologicalsection_enhance_metrourban + 
                values.output_dollars_ecologicalsection_enhance_forestprairie +
                values.output_dollars_ecologicalsection_enhance_seforest + 
                values.output_dollars_ecologicalsection_enhance_prairie +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_restore_total +
                values.output_dollars_ecologicalsection_feepilt_total + 
                values.output_dollars_ecologicalsection_feewopilt_total + 
                values.output_dollars_ecologicalsection_easement_total +
                values.output_dollars_ecologicalsection_enhance_total;
        }
        if (values.eco_regions.indexOf("Northern Forest") === -1) {
            values.lsohc_section_priorities = values.lsohc_section_priorities.filter(
                item => (
                    item !== "Northern Forest - Protect shoreland and restore or enhance critical habitat on wild rice lakes, shallow lakes, cold water lakes, streams and rivers, and spawning areas" &&
                    item !== "Northern Forest - Protect forestland though acquisition or easement to prevent parcelization and fragmentation and to provide the ability to access and manage landlocked public properties" &&
                    item !== "Northern Forest - Provide access to manage habitat on landlocked public properties or protect forest land from parcelization and fragmentation through fee acquisition, conservation or access easement" &&
                    item !== "Northern Forest - Restore and enhance habitat on existing protected properties, with preference to habitat for rare, endangered, or threatened species identified by the Minnesota County Biological Survey" &&
                    item !== "Northern Forest - Restore forest-based wildlife habitat that has experienced substantial decline in area in recent decades" &&
                    item !== "Northern Forest - Protect from long-term or permanent endangerment from invasive species"
                )
            )//p/ap
            values.outcomes_northern_forest = [];//all
            values.outcomes_northern_forest_explain = null;//all
            values.output_acres_ecologicalsection_restore_northernforest = 0;
            values.output_acres_ecologicalsection_feepilt_northernforest = 0;
            values.output_acres_ecologicalsection_feewopilt_northernforest = 0;
            values.output_acres_ecologicalsection_easement_northernforest = 0;
            values.output_acres_ecologicalsection_enhance_northernforest = 0;
            values.output_dollars_ecologicalsection_restore_northernforest = 0;
            values.output_dollars_ecologicalsection_feepilt_northernforest = 0;
            values.output_dollars_ecologicalsection_feewopilt_northernforest = 0;
            values.output_dollars_ecologicalsection_easement_northernforest = 0;
            values.output_dollars_ecologicalsection_enhance_northernforest = 0;
            values.output_acres_ecologicalsection_total_northernforest = 0;
            values.output_dollars_ecologicalsection_total_northernforest = 0;
            values.output_acres_ecologicalsection_restore_total = 
                values.output_acres_ecologicalsection_restore_metrourban + 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_restore_seforest + 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_restore_northernforest;
            values.output_acres_ecologicalsection_feepilt_total = 
                values.output_acres_ecologicalsection_feepilt_metrourban + 
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feepilt_seforest + 
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feepilt_northernforest;
            values.output_acres_ecologicalsection_feewopilt_total = 
                values.output_acres_ecologicalsection_feewopilt_metrourban + 
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_seforest + 
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_northernforest;
            values.output_acres_ecologicalsection_easement_total = 
                values.output_acres_ecologicalsection_easement_metrourban + 
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_easement_seforest + 
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_easement_northernforest;
            values.output_acres_ecologicalsection_enhance_total = 
                values.output_acres_ecologicalsection_enhance_metrourban + 
                values.output_acres_ecologicalsection_enhance_forestprairie +
                values.output_acres_ecologicalsection_enhance_seforest + 
                values.output_acres_ecologicalsection_enhance_prairie +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_restore_total +
                values.output_acres_ecologicalsection_feepilt_total + 
                values.output_acres_ecologicalsection_feewopilt_total + 
                values.output_acres_ecologicalsection_easement_total +
                values.output_acres_ecologicalsection_enhance_total;
            values.output_dollars_ecologicalsection_restore_total = 
                values.output_dollars_ecologicalsection_restore_metrourban + 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_restore_seforest + 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_restore_northernforest;
            values.output_dollars_ecologicalsection_feepilt_total = 
                values.output_dollars_ecologicalsection_feepilt_metrourban + 
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_seforest + 
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feepilt_northernforest;
            values.output_dollars_ecologicalsection_feewopilt_total = 
                values.output_dollars_ecologicalsection_feewopilt_metrourban + 
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_seforest + 
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_northernforest;
            values.output_dollars_ecologicalsection_easement_total = 
                values.output_dollars_ecologicalsection_easement_metrourban + 
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_easement_seforest + 
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_easement_northernforest;
            values.output_dollars_ecologicalsection_enhance_total = 
                values.output_dollars_ecologicalsection_enhance_metrourban + 
                values.output_dollars_ecologicalsection_enhance_forestprairie +
                values.output_dollars_ecologicalsection_enhance_seforest + 
                values.output_dollars_ecologicalsection_enhance_prairie +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_restore_total +
                values.output_dollars_ecologicalsection_feepilt_total + 
                values.output_dollars_ecologicalsection_feewopilt_total + 
                values.output_dollars_ecologicalsection_easement_total +
                values.output_dollars_ecologicalsection_enhance_total;
        }
        if (values.eco_regions.indexOf("Prairie") === -1) {
            values.lsohc_section_priorities = values.lsohc_section_priorities.filter(
                item => (
                    item !== "Prairie - Protect, enhance, and restore remnant native prairie, Big Woods forests, and oak savanna" &&
                    item !== "Prairie - Protect, enhance, and restore migratory habitat for waterfowl and related species, so as to increase migratory and breeding success" &&
                    item !== "Prairie - Protect, enhance, or restore existing wetland/upland complexes, or convert agricultural lands to new wetland/upland habitat complexes" &&
                    item !== "Prairie - Protect expiring CRP lands" &&
                    item !== "Prairie - Convert agricultural land to wetland/upland to protect, enhance, or restore existing habitat complexes, such as WMAs" &&
                    item !== "Prairie - Protect from long-term or permanent endangerment from invasive species" &&
                    item !== "Prairie - Protect, restore, and enhance shallow lakes" &&
                    item !== "Prairie - Restore or enhance habitat on public lands"
                )
            )//p/ap
            values.outcomes_prairie = [];//all
            values.outcomes_prairie_explain = null;//all
            values.output_acres_ecologicalsection_restore_prairie = 0;
            values.output_acres_ecologicalsection_feepilt_prairie = 0;
            values.output_acres_ecologicalsection_feewopilt_prairie = 0;
            values.output_acres_ecologicalsection_easement_prairie = 0;
            values.output_acres_ecologicalsection_enhance_prairie = 0;
            values.output_dollars_ecologicalsection_restore_prairie = 0;
            values.output_dollars_ecologicalsection_feepilt_prairie = 0;
            values.output_dollars_ecologicalsection_feewopilt_prairie = 0;
            values.output_dollars_ecologicalsection_easement_prairie = 0;
            values.output_dollars_ecologicalsection_enhance_prairie = 0;
            values.output_acres_ecologicalsection_total_prairie = 0;
            values.output_dollars_ecologicalsection_total_prairie = 0;
            values.output_acres_ecologicalsection_restore_total = 
                values.output_acres_ecologicalsection_restore_metrourban + 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_restore_seforest + 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_restore_northernforest;
            values.output_acres_ecologicalsection_feepilt_total = 
                values.output_acres_ecologicalsection_feepilt_metrourban + 
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feepilt_seforest + 
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feepilt_northernforest;
            values.output_acres_ecologicalsection_feewopilt_total = 
                values.output_acres_ecologicalsection_feewopilt_metrourban + 
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_seforest + 
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_northernforest;
            values.output_acres_ecologicalsection_easement_total = 
                values.output_acres_ecologicalsection_easement_metrourban + 
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_easement_seforest + 
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_easement_northernforest;
            values.output_acres_ecologicalsection_enhance_total = 
                values.output_acres_ecologicalsection_enhance_metrourban + 
                values.output_acres_ecologicalsection_enhance_forestprairie +
                values.output_acres_ecologicalsection_enhance_seforest + 
                values.output_acres_ecologicalsection_enhance_prairie +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_restore_total +
                values.output_acres_ecologicalsection_feepilt_total + 
                values.output_acres_ecologicalsection_feewopilt_total + 
                values.output_acres_ecologicalsection_easement_total +
                values.output_acres_ecologicalsection_enhance_total;
            values.output_dollars_ecologicalsection_restore_total = 
                values.output_dollars_ecologicalsection_restore_metrourban + 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_restore_seforest + 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_restore_northernforest;
            values.output_dollars_ecologicalsection_feepilt_total = 
                values.output_dollars_ecologicalsection_feepilt_metrourban + 
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_seforest + 
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feepilt_northernforest;
            values.output_dollars_ecologicalsection_feewopilt_total = 
                values.output_dollars_ecologicalsection_feewopilt_metrourban + 
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_seforest + 
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_northernforest;
            values.output_dollars_ecologicalsection_easement_total = 
                values.output_dollars_ecologicalsection_easement_metrourban + 
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_easement_seforest + 
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_easement_northernforest;
            values.output_dollars_ecologicalsection_enhance_total = 
                values.output_dollars_ecologicalsection_enhance_metrourban + 
                values.output_dollars_ecologicalsection_enhance_forestprairie +
                values.output_dollars_ecologicalsection_enhance_seforest + 
                values.output_dollars_ecologicalsection_enhance_prairie +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_restore_total +
                values.output_dollars_ecologicalsection_feepilt_total + 
                values.output_dollars_ecologicalsection_feewopilt_total + 
                values.output_dollars_ecologicalsection_easement_total +
                values.output_dollars_ecologicalsection_enhance_total;
        }
        if (values.eco_regions.indexOf("Southeast Forest") === -1) {
            values.lsohc_section_priorities = values.lsohc_section_priorities.filter(
                item => (
                    item !== "Southeast Forest - Protect, enhance, and restore habitat for fish, game, and nongame wildlife in rivers, cold-water streams, and associated upland habitat" &&
                    item !== "Southeast Forest - Protect, enhance, and restore remnant goat prairies" &&
                    item !== "Southeast Forest - Protect from long-term or permanent endangerment from invasive species" &&
                    item !== "Southeast Forest - Protect forest habitat though acquisition in fee or easement to prevent parcelization and fragmentation and to provide the ability to access and manage landlocked public properties" &&
                    item !== "Southeast Forest - Restore forest-based wildlife habitat that has experienced substantial decline in area in recent decades"
                )
            )//p/ap
            values.outcomes_southeast_forest = [];//all
            values.outcomes_southeast_forest_explain = null;//all
            values.output_acres_ecologicalsection_restore_seforest = 0;
            values.output_acres_ecologicalsection_feepilt_seforest = 0;
            values.output_acres_ecologicalsection_feewopilt_seforest = 0;
            values.output_acres_ecologicalsection_easement_seforest = 0;
            values.output_acres_ecologicalsection_enhance_seforest = 0;
            values.output_dollars_ecologicalsection_restore_seforest = 0;
            values.output_dollars_ecologicalsection_feepilt_seforest = 0;
            values.output_dollars_ecologicalsection_feewopilt_seforest = 0;
            values.output_dollars_ecologicalsection_easement_seforest = 0;
            values.output_dollars_ecologicalsection_enhance_seforest = 0;
            values.output_acres_ecologicalsection_total_seforest = 0;
            values.output_dollars_ecologicalsection_total_seforest = 0;
            values.output_acres_ecologicalsection_restore_total = 
                values.output_acres_ecologicalsection_restore_metrourban + 
                values.output_acres_ecologicalsection_restore_forestprairie +
                values.output_acres_ecologicalsection_restore_seforest + 
                values.output_acres_ecologicalsection_restore_prairie +
                values.output_acres_ecologicalsection_restore_northernforest;
            values.output_acres_ecologicalsection_feepilt_total = 
                values.output_acres_ecologicalsection_feepilt_metrourban + 
                values.output_acres_ecologicalsection_feepilt_forestprairie +
                values.output_acres_ecologicalsection_feepilt_seforest + 
                values.output_acres_ecologicalsection_feepilt_prairie +
                values.output_acres_ecologicalsection_feepilt_northernforest;
            values.output_acres_ecologicalsection_feewopilt_total = 
                values.output_acres_ecologicalsection_feewopilt_metrourban + 
                values.output_acres_ecologicalsection_feewopilt_forestprairie +
                values.output_acres_ecologicalsection_feewopilt_seforest + 
                values.output_acres_ecologicalsection_feewopilt_prairie +
                values.output_acres_ecologicalsection_feewopilt_northernforest;
            values.output_acres_ecologicalsection_easement_total = 
                values.output_acres_ecologicalsection_easement_metrourban + 
                values.output_acres_ecologicalsection_easement_forestprairie +
                values.output_acres_ecologicalsection_easement_seforest + 
                values.output_acres_ecologicalsection_easement_prairie +
                values.output_acres_ecologicalsection_easement_northernforest;
            values.output_acres_ecologicalsection_enhance_total = 
                values.output_acres_ecologicalsection_enhance_metrourban + 
                values.output_acres_ecologicalsection_enhance_forestprairie +
                values.output_acres_ecologicalsection_enhance_seforest + 
                values.output_acres_ecologicalsection_enhance_prairie +
                values.output_acres_ecologicalsection_enhance_northernforest;
            values.output_acres_ecologicalsection_total_total = 
                values.output_acres_ecologicalsection_restore_total +
                values.output_acres_ecologicalsection_feepilt_total + 
                values.output_acres_ecologicalsection_feewopilt_total + 
                values.output_acres_ecologicalsection_easement_total +
                values.output_acres_ecologicalsection_enhance_total;
            values.output_dollars_ecologicalsection_restore_total = 
                values.output_dollars_ecologicalsection_restore_metrourban + 
                values.output_dollars_ecologicalsection_restore_forestprairie +
                values.output_dollars_ecologicalsection_restore_seforest + 
                values.output_dollars_ecologicalsection_restore_prairie +
                values.output_dollars_ecologicalsection_restore_northernforest;
            values.output_dollars_ecologicalsection_feepilt_total = 
                values.output_dollars_ecologicalsection_feepilt_metrourban + 
                values.output_dollars_ecologicalsection_feepilt_forestprairie +
                values.output_dollars_ecologicalsection_feepilt_seforest + 
                values.output_dollars_ecologicalsection_feepilt_prairie +
                values.output_dollars_ecologicalsection_feepilt_northernforest;
            values.output_dollars_ecologicalsection_feewopilt_total = 
                values.output_dollars_ecologicalsection_feewopilt_metrourban + 
                values.output_dollars_ecologicalsection_feewopilt_forestprairie +
                values.output_dollars_ecologicalsection_feewopilt_seforest + 
                values.output_dollars_ecologicalsection_feewopilt_prairie +
                values.output_dollars_ecologicalsection_feewopilt_northernforest;
            values.output_dollars_ecologicalsection_easement_total = 
                values.output_dollars_ecologicalsection_easement_metrourban + 
                values.output_dollars_ecologicalsection_easement_forestprairie +
                values.output_dollars_ecologicalsection_easement_seforest + 
                values.output_dollars_ecologicalsection_easement_prairie +
                values.output_dollars_ecologicalsection_easement_northernforest;
            values.output_dollars_ecologicalsection_enhance_total = 
                values.output_dollars_ecologicalsection_enhance_metrourban + 
                values.output_dollars_ecologicalsection_enhance_forestprairie +
                values.output_dollars_ecologicalsection_enhance_seforest + 
                values.output_dollars_ecologicalsection_enhance_prairie +
                values.output_dollars_ecologicalsection_enhance_northernforest;
            values.output_dollars_ecologicalsection_total_total = 
                values.output_dollars_ecologicalsection_restore_total +
                values.output_dollars_ecologicalsection_feepilt_total + 
                values.output_dollars_ecologicalsection_feewopilt_total + 
                values.output_dollars_ecologicalsection_easement_total +
                values.output_dollars_ecologicalsection_enhance_total;
        }
        if (values.priority_resources_activity.indexOf("Wetlands") === -1) {
            values.output_acres_resourcetype_restore_wetland = 0;
            values.output_acres_resourcetype_feepilt_wetland = 0;
            values.output_acres_resourcetype_feewopilt_wetland = 0;
            values.output_acres_resourcetype_easement_wetland = 0;
            values.output_acres_resourcetype_enhance_wetland = 0;
            values.output_dollars_resourcetype_restore_wetland = 0;
            values.output_dollars_resourcetype_feepilt_wetland = 0;
            values.output_dollars_resourcetype_feewopilt_wetland = 0;
            values.output_dollars_resourcetype_easement_wetland = 0;
            values.output_dollars_resourcetype_enhance_wetland = 0;
            values.output_acres_resourcetype_total_wetland = 0;
            values.output_dollars_resourcetype_total_wetland = 0;
            
            values.output_acres_resourcetype_restore_total = 
                values.output_acres_resourcetype_restore_wetland + 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_restore_forest + 
                values.output_acres_resourcetype_restore_habitat;
            values.output_acres_resourcetype_feepilt_total = 
                values.output_acres_resourcetype_feepilt_wetland + 
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feepilt_forest + 
                values.output_acres_resourcetype_feepilt_habitat;
            values.output_acres_resourcetype_feewopilt_total = 
                values.output_acres_resourcetype_feewopilt_wetland + 
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_feewopilt_forest + 
                values.output_acres_resourcetype_feewopilt_habitat;
            values.output_acres_resourcetype_easement_total = 
                values.output_acres_resourcetype_easement_wetland + 
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_easement_forest + 
                values.output_acres_resourcetype_easement_habitat;
            values.output_acres_resourcetype_enhance_total = 
                values.output_acres_resourcetype_enhance_wetland + 
                values.output_acres_resourcetype_enhance_prairie +
                values.output_acres_resourcetype_enhance_forest + 
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie + 
                values.output_acres_resourcetype_total_forest + 
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_restore_total = 
                values.output_dollars_resourcetype_restore_wetland + 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_restore_forest + 
                values.output_dollars_resourcetype_restore_habitat;
            values.output_dollars_resourcetype_feepilt_total = 
                values.output_dollars_resourcetype_feepilt_wetland + 
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feepilt_forest + 
                values.output_dollars_resourcetype_feepilt_habitat;
            values.output_dollars_resourcetype_feewopilt_total = 
                values.output_dollars_resourcetype_feewopilt_wetland + 
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_feewopilt_forest + 
                values.output_dollars_resourcetype_feewopilt_habitat;
            values.output_dollars_resourcetype_easement_total = 
                values.output_dollars_resourcetype_easement_wetland + 
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_easement_forest + 
                values.output_dollars_resourcetype_easement_habitat;
            values.output_dollars_resourcetype_enhance_total = 
                values.output_dollars_resourcetype_enhance_wetland + 
                values.output_dollars_resourcetype_enhance_prairie +
                values.output_dollars_resourcetype_enhance_forest + 
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie + 
                values.output_dollars_resourcetype_total_forest + 
                values.output_dollars_resourcetype_total_habitat;
        }
        if (values.priority_resources_activity.indexOf("Forest") === -1) {
            values.output_acres_resourcetype_restore_forest = 0;
            values.output_acres_resourcetype_feepilt_forest = 0;
            values.output_acres_resourcetype_feewopilt_forest = 0;
            values.output_acres_resourcetype_easement_forest = 0;
            values.output_acres_resourcetype_enhance_forest = 0;
            values.output_dollars_resourcetype_restore_forest = 0;
            values.output_dollars_resourcetype_feepilt_forest = 0;
            values.output_dollars_resourcetype_feewopilt_forest = 0;
            values.output_dollars_resourcetype_easement_forest = 0;
            values.output_dollars_resourcetype_enhance_forest = 0;
            values.output_acres_resourcetype_total_forest = 0;
            values.output_dollars_resourcetype_total_forest = 0;
            
            values.output_acres_resourcetype_restore_total = 
                values.output_acres_resourcetype_restore_wetland + 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_restore_forest + 
                values.output_acres_resourcetype_restore_habitat;
            values.output_acres_resourcetype_feepilt_total = 
                values.output_acres_resourcetype_feepilt_wetland + 
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feepilt_forest + 
                values.output_acres_resourcetype_feepilt_habitat;
            values.output_acres_resourcetype_feewopilt_total = 
                values.output_acres_resourcetype_feewopilt_wetland + 
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_feewopilt_forest + 
                values.output_acres_resourcetype_feewopilt_habitat;
            values.output_acres_resourcetype_easement_total = 
                values.output_acres_resourcetype_easement_wetland + 
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_easement_forest + 
                values.output_acres_resourcetype_easement_habitat;
            values.output_acres_resourcetype_enhance_total = 
                values.output_acres_resourcetype_enhance_wetland + 
                values.output_acres_resourcetype_enhance_prairie +
                values.output_acres_resourcetype_enhance_forest + 
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie + 
                values.output_acres_resourcetype_total_forest + 
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_restore_total = 
                values.output_dollars_resourcetype_restore_wetland + 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_restore_forest + 
                values.output_dollars_resourcetype_restore_habitat;
            values.output_dollars_resourcetype_feepilt_total = 
                values.output_dollars_resourcetype_feepilt_wetland + 
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feepilt_forest + 
                values.output_dollars_resourcetype_feepilt_habitat;
            values.output_dollars_resourcetype_feewopilt_total = 
                values.output_dollars_resourcetype_feewopilt_wetland + 
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_feewopilt_forest + 
                values.output_dollars_resourcetype_feewopilt_habitat;
            values.output_dollars_resourcetype_easement_total = 
                values.output_dollars_resourcetype_easement_wetland + 
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_easement_forest + 
                values.output_dollars_resourcetype_easement_habitat;
            values.output_dollars_resourcetype_enhance_total = 
                values.output_dollars_resourcetype_enhance_wetland + 
                values.output_dollars_resourcetype_enhance_prairie +
                values.output_dollars_resourcetype_enhance_forest + 
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie + 
                values.output_dollars_resourcetype_total_forest + 
                values.output_dollars_resourcetype_total_habitat;
        }
        if (values.priority_resources_activity.indexOf("Prairie") === -1) {
            values.output_acres_resourcetype_restore_prairie = 0;
            values.output_acres_resourcetype_feepilt_prairie = 0;
            values.output_acres_resourcetype_feewopilt_prairie = 0;
            values.output_acres_resourcetype_easement_prairie = 0;
            values.output_acres_resourcetype_enhance_prairie = 0;
            values.output_dollars_resourcetype_restore_prairie = 0;
            values.output_dollars_resourcetype_feepilt_prairie = 0;
            values.output_dollars_resourcetype_feewopilt_prairie = 0;
            values.output_dollars_resourcetype_easement_prairie = 0;
            values.output_dollars_resourcetype_enhance_prairie = 0;
            values.output_acres_resourcetype_total_prairie = 0;
            values.output_dollars_resourcetype_total_prairie = 0;
            
            values.output_acres_resourcetype_restore_total = 
                values.output_acres_resourcetype_restore_wetland + 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_restore_forest + 
                values.output_acres_resourcetype_restore_habitat;
            values.output_acres_resourcetype_feepilt_total = 
                values.output_acres_resourcetype_feepilt_wetland + 
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feepilt_forest + 
                values.output_acres_resourcetype_feepilt_habitat;
            values.output_acres_resourcetype_feewopilt_total = 
                values.output_acres_resourcetype_feewopilt_wetland + 
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_feewopilt_forest + 
                values.output_acres_resourcetype_feewopilt_habitat;
            values.output_acres_resourcetype_easement_total = 
                values.output_acres_resourcetype_easement_wetland + 
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_easement_forest + 
                values.output_acres_resourcetype_easement_habitat;
            values.output_acres_resourcetype_enhance_total = 
                values.output_acres_resourcetype_enhance_wetland + 
                values.output_acres_resourcetype_enhance_prairie +
                values.output_acres_resourcetype_enhance_forest + 
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie + 
                values.output_acres_resourcetype_total_forest + 
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_restore_total = 
                values.output_dollars_resourcetype_restore_wetland + 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_restore_forest + 
                values.output_dollars_resourcetype_restore_habitat;
            values.output_dollars_resourcetype_feepilt_total = 
                values.output_dollars_resourcetype_feepilt_wetland + 
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feepilt_forest + 
                values.output_dollars_resourcetype_feepilt_habitat;
            values.output_dollars_resourcetype_feewopilt_total = 
                values.output_dollars_resourcetype_feewopilt_wetland + 
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_feewopilt_forest + 
                values.output_dollars_resourcetype_feewopilt_habitat;
            values.output_dollars_resourcetype_easement_total = 
                values.output_dollars_resourcetype_easement_wetland + 
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_easement_forest + 
                values.output_dollars_resourcetype_easement_habitat;
            values.output_dollars_resourcetype_enhance_total = 
                values.output_dollars_resourcetype_enhance_wetland + 
                values.output_dollars_resourcetype_enhance_prairie +
                values.output_dollars_resourcetype_enhance_forest + 
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie + 
                values.output_dollars_resourcetype_total_forest + 
                values.output_dollars_resourcetype_total_habitat;
        }
        if (values.priority_resources_activity.indexOf("Habitat") === -1) {
            values.output_acres_resourcetype_restore_habitat = 0;
            values.output_acres_resourcetype_feepilt_habitat = 0;
            values.output_acres_resourcetype_feewopilt_habitat = 0;
            values.output_acres_resourcetype_easement_habitat = 0;
            values.output_acres_resourcetype_enhance_habitat = 0;
            values.output_dollars_resourcetype_restore_habitat = 0;
            values.output_dollars_resourcetype_feepilt_habitat = 0;
            values.output_dollars_resourcetype_feewopilt_habitat = 0;
            values.output_dollars_resourcetype_easement_habitat = 0;
            values.output_dollars_resourcetype_enhance_habitat = 0;
            values.output_acres_resourcetype_total_habitat = 0;
            values.output_dollars_resourcetype_total_habitat = 0;
            
            values.output_acres_resourcetype_restore_total = 
                values.output_acres_resourcetype_restore_wetland + 
                values.output_acres_resourcetype_restore_prairie +
                values.output_acres_resourcetype_restore_forest + 
                values.output_acres_resourcetype_restore_habitat;
            values.output_acres_resourcetype_feepilt_total = 
                values.output_acres_resourcetype_feepilt_wetland + 
                values.output_acres_resourcetype_feepilt_prairie +
                values.output_acres_resourcetype_feepilt_forest + 
                values.output_acres_resourcetype_feepilt_habitat;
            values.output_acres_resourcetype_feewopilt_total = 
                values.output_acres_resourcetype_feewopilt_wetland + 
                values.output_acres_resourcetype_feewopilt_prairie +
                values.output_acres_resourcetype_feewopilt_forest + 
                values.output_acres_resourcetype_feewopilt_habitat;
            values.output_acres_resourcetype_easement_total = 
                values.output_acres_resourcetype_easement_wetland + 
                values.output_acres_resourcetype_easement_prairie +
                values.output_acres_resourcetype_easement_forest + 
                values.output_acres_resourcetype_easement_habitat;
            values.output_acres_resourcetype_enhance_total = 
                values.output_acres_resourcetype_enhance_wetland + 
                values.output_acres_resourcetype_enhance_prairie +
                values.output_acres_resourcetype_enhance_forest + 
                values.output_acres_resourcetype_enhance_habitat;
            values.output_acres_resourcetype_total_total = 
                values.output_acres_resourcetype_total_wetland +
                values.output_acres_resourcetype_total_prairie + 
                values.output_acres_resourcetype_total_forest + 
                values.output_acres_resourcetype_total_habitat;
            values.output_dollars_resourcetype_restore_total = 
                values.output_dollars_resourcetype_restore_wetland + 
                values.output_dollars_resourcetype_restore_prairie +
                values.output_dollars_resourcetype_restore_forest + 
                values.output_dollars_resourcetype_restore_habitat;
            values.output_dollars_resourcetype_feepilt_total = 
                values.output_dollars_resourcetype_feepilt_wetland + 
                values.output_dollars_resourcetype_feepilt_prairie +
                values.output_dollars_resourcetype_feepilt_forest + 
                values.output_dollars_resourcetype_feepilt_habitat;
            values.output_dollars_resourcetype_feewopilt_total = 
                values.output_dollars_resourcetype_feewopilt_wetland + 
                values.output_dollars_resourcetype_feewopilt_prairie +
                values.output_dollars_resourcetype_feewopilt_forest + 
                values.output_dollars_resourcetype_feewopilt_habitat;
            values.output_dollars_resourcetype_easement_total = 
                values.output_dollars_resourcetype_easement_wetland + 
                values.output_dollars_resourcetype_easement_prairie +
                values.output_dollars_resourcetype_easement_forest + 
                values.output_dollars_resourcetype_easement_habitat;
            values.output_dollars_resourcetype_enhance_total = 
                values.output_dollars_resourcetype_enhance_wetland + 
                values.output_dollars_resourcetype_enhance_prairie +
                values.output_dollars_resourcetype_enhance_forest + 
                values.output_dollars_resourcetype_enhance_habitat;
            values.output_dollars_resourcetype_total_total = 
                values.output_dollars_resourcetype_total_wetland +
                values.output_dollars_resourcetype_total_prairie + 
                values.output_dollars_resourcetype_total_forest + 
                values.output_dollars_resourcetype_total_habitat;
        }

        ormProposalUpdate({
            id: id,
            ...values
        });

        handleUnsavedFields(false);

        if (!Number.isInteger(fromStepper)) {
            if (this.state.draftClick) {
                history.push("/dashboard/");
            } else {
                handleNext();
            }
        }
    };

    applyActivityOther = value => {
        const { ormProposalUpdateLocalOnly } = this.props;
        const { id } = this.props.proposal;
        ormProposalUpdateLocalOnly({
            id: id,
            activity_types: value
        });
        this.setState({ foo: "bar" });
    };

    render() {
        const { classes, proposal, handleUnsavedFields, settings, ActionMenu, authState } = this.props; 
        var is_read_only = true;
        if ((authState && authState.user && authState.user.role === "admin") || proposal.status === "New")
            is_read_only = false;
        if (authState && authState.user && authState.user.role === "readonly")
            is_read_only = true;

        var is_admin = false;
        if (authState && authState.user && authState.user.role === "admin") {
            is_admin = true;
        }

        const showOther = getValue(proposal, "activity_types").indexOf("Other") > -1;

        return (
            <Form
                getApi={el => (this.form = el)}
                key={proposal.id}
                dontValidateOnMount={true}
                validateOnSubmit={true}
                defaultValues={proposal.formData}
                formDidUpdate={() => handleUnsavedFields(true)}
                validateError={values => this.errorValidator(values)}
                onSubmit={(values, fromStepper) => this.updateProposal(values, fromStepper)}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={10} lg={12} xl={10}>
                                <HelpLabel
                                    inputLabel="Management Information"
                                    title={true}
                                    showLabel={true}
                                    helpText={settings.general_tab_help}
                                />
                                {ActionMenu}
                            </Grid>
                            <Grid item xs={12} md={10} lg={8} xl={6}>
                                <TextField disabled={is_read_only} field="name" fullWidth>
                                    <HelpLabel
                                        inputLabel="Project or Program Title"
                                        showLabel={true}
                                        helpText="Project or Program Title should be descriptive and include the correct program phase, if applicable."
                                    />
                                </TextField>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField field="ml_year" label="Session Year" readOnly fullWidth />
                                        <TextField
                                            field="funds_requested"
                                            fullWidth readOnly>
                                                <HelpLabel
                                                    inputLabel="Funds Requested ($)"
                                                    showLabel={true}
                                                    helpText="The Funds Requested field will be auto-populated once the budget tab is completed."
                                                />
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField field="create_date_label" label="Created Date" fullWidth readOnly />
                                        <TextField field="modify_date_label" label="Modified Date" readOnly fullWidth />
                                    </Grid>
                                </Grid>
                                <Typography variant="h3" className={classes.gutterTop}>
                                    Organization
                                </Typography>
                                <Grid container spacing={2}>
                                    {is_admin && (
                                        <Grid item xs={7}>
                                            <TextField field="user_id" label="User ID" fullWidth />
                                        </Grid>
                                    )}
                                    <Grid item xs={6}>
                                        <TextField disabled={is_read_only} field="manager_name" label="Manager's Name" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_title" label="Title" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_organization" label="Organization Name" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_address" label="Address" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_address2" label="Address 2" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_city" label="City" fullWidth />
                                        <Select disabled={is_read_only} field="manager_state" label="State" options={states} fullWidth />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField disabled={is_read_only} field="manager_zip" label="Zip" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_email" label="Email" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_office_number" label="Office Number" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_mobile_number" label="Mobile Number" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_fax_number" label="Fax Number" fullWidth />
                                        <TextField disabled={is_read_only} field="manager_website" label="Website" fullWidth />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={8} lg={4} xl={4}>
                                <CheckboxGroup
                                    field="eco_regions"
                                    row={true}
                                    width={205}
                                    disabled={is_read_only}
                                    options={MAKE_OPTIONS([
                                        "Forest / Prairie Transition",
                                        "Metro / Urban",
                                        "Northern Forest",
                                        "Prairie",
                                        "Southeast Forest"
                                    ])}>
                                        <HelpLabel
                                            inputLabel="Eco regions in which work will take place"
                                            showLabel={true}
                                            helpText={
                                                <div>
                                                    Check all that apply.
                                                    <br />
                                                    <br />
                                                    Selections made for Regions will trigger unique questions throughout
                                                    the application, including the control fields in the Output Tables
                                                    Tab.
                                                    <br />
                                                    <br />
                                                    <a
                                                        href="https://www.lsohc.leg.mn/materials/resource_doc_plan/lsohc_county_city.pdf"
                                                        target="_blank"
                                                        rel="noopener noreferrer">
                                                        Region Map
                                                    </a>
                                                </div>
                                            }
                                        />
                                </CheckboxGroup>
                                <CheckboxGroup
                                    field="activity_types"
                                    row={true}
                                    width={205}
                                    disabled={is_read_only}
                                    eventHandle={this.applyActivityOther}
                                    options={MAKE_OPTIONS([
                                        "Enhance",
                                        "Protect in Easement",
                                        "Protect in Fee",
                                        "Restore",
                                        "Other"
                                    ])}
                                    >
                                        <HelpLabel
                                            inputLabel="Activity types"
                                            showLabel={true}
                                            helpText={
                                                <div>
                                                    Check all that apply.
                                                    <br />
                                                    <br />
                                                    Selections made for Activity type will trigger unique questions
                                                    throughout the application, including the control fields in the
                                                    Output Tables Tab.
                                                </div>
                                            }
                                        />
                                </CheckboxGroup>
                                {showOther && (
                                    <TextField
                                        field="activity_types_other"
                                        disabled={is_read_only}
                                        label="What is your other activity type?"
                                        fullWidth
                                    />
                                )}
                                <CheckboxGroup
                                    field="priority_resources_activity"
                                    row={true}
                                    disabled={is_read_only}
                                    width={205}
                                    options={MAKE_OPTIONS(["Forest", "Habitat", "Prairie", "Wetlands"])}
                                >
                                        <HelpLabel
                                            inputLabel="Priority resources addressed by activity"
                                            showLabel={true}
                                            helpText={
                                                <div>
                                                    Check all that apply.
                                                    <br />
                                                    <br />
                                                    Selections made for Priority resources will trigger unique questions
                                                    throughout the application, including the control fields in the
                                                    Output Tables Tab.
                                                </div>
                                            }
                                        />
                                    </CheckboxGroup>
                            </Grid>
                            <Grid item xs={12} xl={10} className={classes.rightAlign}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={is_read_only}
                                    onClick={() => this.setState({ draftClick: true, submitClicked: true })}
                                    className={classes.button}>
                                    Save Draft and Return to Dashboard
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    disabled={is_read_only}
                                    color="primary"
                                    onClick={() => this.setState({ draftClick: false, submitClicked: true })}>
                                    Save and Proceed to Narrative <ChevronRightIcon />
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </Form>
        );
    }
}

GeneralTab = connect(
    (state, ownProps) => ({
        authState: state.auth
    }),
    {
        ...Proposal.actions
    }
)(GeneralTab);

export default withStyles(styles)(withRouter(GeneralTab));
